import * as Yup from 'yup';

export function categoryValidator() {
  return Yup.object().shape({
    name: Yup
      .string()
      .required('Por favor, informe um mome válido para prosseguir.'),
  });
}
